/** Alternation belongs to the page's text order, never React's render order. */
export function syllableParity(rheses: readonly { letters: readonly {
  syllableId?: string | null; absoluteTextPosition: number;
}[] }[]) {
  let lastId: string | undefined;
  let count = 0;
  const parity = new Map<number, boolean>();
  for (const rhese of rheses) for (const letter of rhese.letters) {
    if (!letter.syllableId) continue;
    if (letter.syllableId !== lastId) { count++; lastId = letter.syllableId; }
    parity.set(letter.absoluteTextPosition, count % 2 === 0);
  }
  return parity;
}
